/**
 * Updates the content of the page components without the need to update the entire application.
 * @param element (Optional) HTML element that will dispatch the reload event.
 * @returns Returns true if the reload event was successfully dispatched, otherwise, it returns false.
 */
export function reloadPageContent(element) {
    const reloadEvent = new CustomEvent('syAppCustomPageReloadElements', { bubbles: true });
    if (element) {
        return element.dispatchEvent(reloadEvent);
    }
    return document.body.dispatchEvent(reloadEvent);
}
